<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Archive
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <!-- Filters -->
                                <v-row class="py-2">
                                    <v-col md="3" cols="12">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            hide-details
                                            clearable
                                        />
                                    </v-col>

                                    <v-col md="2" cols="12">
                                        <v-date-input
                                            v-model="fromDate"
                                            label="From Date"
                                            density="compact"
                                            variant="outlined"
                                            hide-details
                                            append-icon=""
                                        />
                                    </v-col>

                                    <v-col md="2" cols="12">
                                        <v-date-input
                                            v-model="toDate"
                                            label="To Date"
                                            density="compact"
                                            variant="outlined"
                                            hide-details
                                            append-icon=""
                                        />
                                    </v-col>
                                </v-row>


                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col cols="12">
                    <v-expansion-panels v-model="panel1">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Archive list
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <!-- Filters -->
                                <v-row class="py-2">
                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>

                                <!-- Table -->
                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    density="compact"
                                    hover
                                >
                                    <template #item.index="{ index }">
                                        {{ index + 1 }}
                                    </template>

                                    <template #item.status="{ item }">
                                        <v-chip
                                            :color="item.status == 1 ? 'success' : 'red'"
                                            size="small"
                                        >
                                            {{ item.status == 1 ? 'Active' : 'Inactive' }}
                                        </v-chip>
                                    </template>

                                    <template #item.actions="{ item }">
                                        <v-icon
                                            v-if="$updateAccess($route.fullPath)"
                                            class="me-2"
                                            color="primary"
                                            @click="editItem(item)"
                                        >
                                            mdi-pencil-outline
                                        </v-icon>
                                    </template>
                                </v-data-table>

                                
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import formattedDate from "@/plugins/dateFormatter"

/*
|--------------------------------------------------------------------------
| Store
|--------------------------------------------------------------------------
*/
const store = useStore()

/*
|--------------------------------------------------------------------------
| Reactive State
|--------------------------------------------------------------------------
*/
const panel = ref([0])
const panel1 = ref([0])
const loading = ref(false)
const search = ref('')
const fromDate = ref('')
const toDate = ref('')
const itemsPerPage = ref(10)
const page = ref(1)

/*
|--------------------------------------------------------------------------
| Table Headers
|--------------------------------------------------------------------------
*/
const headers = [
    { title: '#SL', key: 'index', align: 'center', sortable: false, width: '7%' },
    { title: 'Code', key: 'code', align: 'left', sortable: false },
    { title: 'Name', key: 'name', align: 'left', sortable: false },
    { title: 'Status', key: 'status', align: 'center', sortable: true },
    { title: 'Actions', key: 'actions', align: 'center', sortable: false }
]

/*
|--------------------------------------------------------------------------
| Computed
|--------------------------------------------------------------------------
*/
const getSchema = computed(() => {
    return store.getters.getArchivedDocumentsList?.data || []
})

/*
|--------------------------------------------------------------------------
| Fetch Data
|--------------------------------------------------------------------------
*/
const fetchData = () => {
    loading.value = true

    store.dispatch('getArchivedDocumentsList', {
        search: search.value,
        from_date: formattedDate(fromDate.value ?? null),
        to_date: formattedDate(toDate.value ?? null),
        per_page: itemsPerPage.value,
        page: page.value
    }).finally(() => {
        loading.value = false
    })
}

/*
|--------------------------------------------------------------------------
| Lifecycle
|--------------------------------------------------------------------------
*/
onMounted(fetchData)

/*
|--------------------------------------------------------------------------
| Watchers
|--------------------------------------------------------------------------
*/
watch(search, () => {
    page.value = 1
    fetchData()
})

watch([fromDate, toDate], () => {
    page.value = 1
    fetchData()
})

watch(itemsPerPage, () => {
    page.value = 1
    fetchData()
})

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const editItem = (item) => {
    console.log('Edit item:', item)
}

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/
const exportToPDF = () => {
    let i = 1
    const columns = ['#SL', 'Code', 'Name', 'Status']
    const rows = getSchema.value.map(item => [
        i++,
        item.code,
        item.name,
        item.status == 1 ? 'Active' : 'Inactive'
    ])
    window.$exportTableToPDF(columns, rows, 'Archive List', 'archive_' + window.$fileDate())
}

const exportToExcel = () => {
    const rows = [['#SL', 'Code', 'Name', 'Status']]
    let i = 1
    getSchema.value.forEach(item => {
        rows.push([i++, item.code, item.name, item.status == 1 ? 'Active' : 'Inactive'])
    })
    window.$exportTableToExcel(rows, 'archive_' + window.$fileDate())
}

const exportToCSV = () => {
    const rows = [['#SL', 'Code', 'Name', 'Status']]
    let i = 1
    getSchema.value.forEach(item => {
        rows.push([i++, item.code, item.name, item.status == 1 ? 'Active' : 'Inactive'])
    })
    window.$exportTableToCSV(rows, 'archive_' + window.$fileDate())
}
</script>
